import React from 'react';
import routes from '@lialo/core/lib/pages/utils/routes';
import SharePageButton from './SharePageButton';
import { useServiceProvider } from '../Providers';

interface IProps {
  tour: {
    tourCode: string;
    authorId?: string;
    city?: string;
    price?: string;
  };
  button: React.ReactElement<{ onClick: () => void }>;
  snackbarKey?: string;
}

export const ShareTourButton = ({ tour, button, snackbarKey = 'tour_detail.share_message' }: IProps) => {

  const { analyticsService } = useServiceProvider();

  return (
    <SharePageButton
      onShare={() => analyticsService.logShareTour(tour.tourCode, tour.authorId, tour.city, tour.price)}
      url={routes.generateAbsoluteTourLink(tour.tourCode)}
      snackbarKey={snackbarKey}
      button={button}
    />
  );
};

